
import { defineComponent } from 'vue'

export default defineComponent({
    // eslint-disable-next-line vue/multi-word-component-names
    name: 'Box',
    data(){
        return{
            estilos:{
                background: '#FAF0CA'
            }
        }
    }
})
